export default __webpack_public_path__ + "static/media/eduBlue.e5287488.svg";